"use client";

import { LegalDocumentPage } from "@/components/legal/LegalDocumentPage";
import { useLanguage } from "@/context/LanguageContext";

export default function PaymentAgreement() {
  const { language } = useLanguage();
  const copy = {
    cs: {
      title: "Podmínky předplatného",
      subtitle:
        "platné pro službu Hlídací pes na webu softiq.cz/hlidaci-pes od 2.1.2025",
      operatorTitle: "Provozovatel",
      operatorLines: [
        "Službu Hlídací pes provozuje:",
        "Ing. Martin Švejda",
        "IČO: 21086231",
        "Sídlo: Janského 559/13, 779 00, Olomouc – Povel",
        "E-mail: info@softiq.cz",
        "(dále jen „Provozovatel“).",
      ],
      subscription:
        "Předplatné se sjednává na dobu neurčitou s měsíční automatickou obnovou. Po provedení první platby je předplatitelovi každý měsíc automaticky strhávána částka odpovídající zvolenému předplatnému, dokud si svůj účet nezruší. Předplatitel může své předplatné kdykoli ukončit primárně ve svém uživatelském účtu, nebo prostřednictvím e-mailu na adrese info@softiq.cz. Ukončení předplatného se projeví od následujícího zúčtovacího období. Již uhrazené předplatné za aktuální období není možné vrátit. Pokud si předplatitel nepřeje pokračovat v předplatném, je nutné jej aktivně zrušit. V opačném případě bude předplatné automaticky obnovováno a platby budou dále strhávány.",
      renewalTitle: "Předplatné je měsíčně obnovováno automaticky:",
      prices: ["Professional – 249 Kč", "Premium – 129 Kč", "Standard – 49 Kč"],
      recurring:
        "Opakovaná platba probíhá automaticky bez předchozího avíza předplatitele, a to ve výši a periodicitě uvedené při založení objednávky, maximálně do konce platnosti platební karty. V případě, že by opakovaná platba měla být v jiné výši, než bylo uvedeno v objednávce, bude předplatitel o takové změně informován s předstihem prostřednictvím e-mailu.",
      paymentData:
        "Platební údaje jsou uloženy na straně platební brány GoPay, která s údaji nakládá podle mezinárodního bezpečnostního standardu PCI DSS Level 1 (jedná se o nejvyšší úroveň datové bezpečnosti v sektoru zpracovávání platebních karet).",
    },
    en: {
      title: "Subscription Terms",
      subtitle:
        "valid for the Watchdog service at softiq.cz/hlidaci-pes from 2 January 2025",
      operatorTitle: "Operator",
      operatorLines: [
        "The Watchdog service is operated by:",
        "Ing. Martin Švejda",
        "Company ID: 21086231",
        "Registered office: Janského 559/13, 779 00, Olomouc – Povel",
        "E-mail: info@softiq.cz",
        "(hereinafter the “Operator”).",
      ],
      subscription:
        "The subscription is concluded for an indefinite period with automatic monthly renewal. After the first payment is made, the subscriber is automatically charged each month for the amount corresponding to the selected subscription until the account is cancelled. The subscriber may cancel the subscription at any time primarily in the user account, or by e-mail at info@softiq.cz. The cancellation takes effect from the following billing period. Subscription fees already paid for the current period are non-refundable. If the subscriber does not wish to continue the subscription, it must be actively cancelled. Otherwise, the subscription will be renewed automatically and payments will continue to be charged.",
      renewalTitle: "The subscription is renewed automatically each month:",
      prices: [
        "Professional – CZK 249",
        "Premium – CZK 129",
        "Standard – CZK 49",
      ],
      recurring:
        "The recurring payment is made automatically without prior notice to the subscriber, in the amount and frequency stated when the order was created, at most until the payment card expires. If a recurring payment should be made in a different amount than stated in the order, the subscriber will be informed about the change in advance by e-mail.",
      paymentData:
        "Payment details are stored by the GoPay payment gateway, which handles the data according to the international PCI DSS Level 1 security standard, the highest level of data security in the payment card processing sector.",
    },
  }[language];
  const sections = [
    {
      title: copy.operatorTitle,
      paragraphs: [copy.operatorLines.join("\n")],
      text: copy.subscription,
    },
    {
      listIntro: copy.renewalTitle,
      list: copy.prices,
      text: `${copy.recurring}\n\n${copy.paymentData}`,
    },
  ];

  return (
    <LegalDocumentPage
      title={copy.title}
      subtitle={copy.subtitle}
      sections={sections}
    />
  );
}
